var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDeleteTransparent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.646,
    height: 14.453,
    viewBox: "0 0 12.646 14.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M17.195,4.409H13.431V3.2a1.208,1.208,0,0,0-1.2-1.2H10.42a1.208,1.208,0,0,0-1.2,1.2v1.2H5.452A.463.463,0,0,0,5,4.861v.9a.463.463,0,0,0,.452.452H17.195a.463.463,0,0,0,.452-.452v-.9A.463.463,0,0,0,17.195,4.409Zm-6.775-.9a.284.284,0,0,1,.3-.3h1.2a.284.284,0,0,1,.3.3v.9H10.42Z",
    transform: "translate(-5 -2)",
    fill: "#8b9095"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M18.786,20H9.452A.463.463,0,0,0,9,20.452v7.076a1.491,1.491,0,0,0,1.506,1.506h7.227a1.491,1.491,0,0,0,1.506-1.506V20.452A.463.463,0,0,0,18.786,20Zm-5.57,6.624a.284.284,0,0,1-.3.3h-.6a.284.284,0,0,1-.3-.3V22.409a.284.284,0,0,1,.3-.3h.6a.284.284,0,0,1,.3.3Zm3.011,0a.284.284,0,0,1-.3.3h-.6a.284.284,0,0,1-.3-.3V22.409a.284.284,0,0,1,.3-.3h.6a.284.284,0,0,1,.3.3Z",
    transform: "translate(-7.796 -14.58)",
    fill: "#8b9095"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteTransparent);
export default __webpack_public_path__ + "static/media/ic-delete-transparent.52ea4926.svg";
export { ForwardRef as ReactComponent };